import { render, staticRenderFns } from "./preExamSet.vue?vue&type=template&id=5434a3e5&scoped=true&"
import script from "./preExamSet.vue?vue&type=script&lang=js&"
export * from "./preExamSet.vue?vue&type=script&lang=js&"
import style0 from "./preExamSet.vue?vue&type=style&index=0&id=5434a3e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434a3e5",
  null
  
)

export default component.exports